export default __webpack_public_path__ + "static/media/artist2.f7427332.jpg";